import React from "react";
import ReactApexChart from "react-apexcharts";

// let colors = ["#f0f9ba", "#fff1ae", "#fed38c", "#feb669", "#f3854e"];
// let colors = ["#1542E6", "#E63A15", "#59E615", "#fed38c"];
let colors = ["#00b050", "#884106", "#cccc00", "#ff00ff"];

export default class CChart extends React.Component {
  constructor(props) {
    super(props);

    this.state={

    };

  }

  render() {

    console.log('Col Chart test paddy', this.props.cap_stats_paddy);
    console.log('Col Chart test per', this.props.cap_stats_per);
    console.log('Col Chart test id', this.props.cap_stats_id);
    console.log('Col Chart test bi', this.props.cap_stats_bi);
    console.log('Col Chart test date', this.props.cap_stats_date);

    const opt = {
    
      series: [{
        name: 'Paddy',
        // data: [44, 55, 41, 67, 22, 43]
        data: this.props.cap_stats_paddy
      }, {
        name: 'Perinnial',
        data: this.props.cap_stats_per
      }, {
        name: 'Irrigated Dry',
        data: this.props.cap_stats_id
      }, {
        name: 'Biseasonal',
        data: this.props.cap_stats_bi
      }],

      options: {
        chart: {
          type: 'bar',
          // height: 220,
          stacked: true,
          toolbar: {
            // show: false
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false,
          // formatter: function (val) {
          //   return val + "%";
          // },
          // offsetY: -20,
          style: {
            fontSize: '12px',
            colors: ["#304758"]
          }
        },
        colors: colors,
        responsive: [{
          breakpoint: 480,
          options: {
            legend: {
              position: 'bottom',
              offsetX: -10,
              offsetY: 0
            }
          }
        }],
        plotOptions: {
          bar: {
            horizontal: false,
            //borderRadius: 10
          },
        },

        xaxis: {
          title: {
            text: 'Date',
            offsetY: -20,
          },
          type: 'string',
          // type: 'datetime',
          // labels: {
          //   format: 'dd MMM yy',
          //   }, 
          // categories: ['01/01/2011 GMT', '01/02/2011 GMT', '01/03/2011 GMT', '01/04/2011 GMT', '01/05/2011 GMT', '01/06/2011 GMT'],
          categories: this.props.cap_stats_date,
        },

        legend: {
          position: 'top',
          fontSize: '12px',
          floating: true,
          offsetY: 10,
          offsetX: 10,
          onItemClick: {
            toggleDataSeries: false
          },
        },
        fill: {
          opacity: 1
        },
        yaxis: {
          title: {
            text: 'Area (Thousand ha)'
          },
          labels: {
            formatter: function(val) {
              return val.toFixed(2);
            }
          },
        }
      },
    
    
    };

    return (
      

      <div id="chart" style={{height: '100%'}}>
      <ReactApexChart 
        options={opt.options} 
        series={opt.series} 
        type="bar" 
        height={'90%'} 
      />
      </div>


    );
  }
}
